import styled from 'styled-components';

export const ClearButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    font-size: ${({ theme }) => theme.fontSizes[5]};
    line-height: 1.4285714286;
    cursor: pointer;
    text-decoration: underline;
    display: inline-block;
    font-weight: 600;

    &:disabled {
        cursor: not-allowed;
        color: ${({ theme }) => theme.colors.fontPrimaryDisabled};
    }
`;
